import axios from 'axios';
import { auth } from './auth';

const API_BASE = 'https://repochat-b.onrender.com/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      auth.clearToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
};

// Project endpoints  
export const projectAPI = {
  list: () => api.get('/projects'),
  create: (data) => api.post('/projects', data),
  get: (id) => api.get(`/projects/${id}`),
  delete: (id) => api.delete(`/projects/${id}`),
  getStatus: (id) => api.get(`/projects/${id}/status`),
  process: (id) => api.post(`/projects/${id}/process`),
};

// Question endpoints
export const questionAPI = {
  ask: (projectId, question) => api.post(`/questions/${projectId}/ask`, { question }),
  getHistory: (projectId) => api.get(`/questions/${projectId}/history`),
  delete: (questionId) => api.delete(`/questions/${questionId}`),
};

export default api;
